




















































































































































































































import { Vue, Component, Lifecycle, Watch, Prop, p } from "av-ts";
import { IQuestion, IDistractor, ICourseUser } from "../../interfaces/models";
import { addEventsToQueue } from "../../util";
import Comment from "../util/Comment.vue";
import QuestionRater from "./QuestionRater.vue";
import QuestionService from "../../services/QuestionService";
import UserService from "../../services/UserService";
import Fetcher from "../../services/Fetcher";
import * as d3 from "d3";

@Component({
    components: {
        QuestionRater,
        Comment
    }
})
export default class QuestionResponse extends Vue {
    @Prop question = p<IQuestion>({
        required: true
    });

    @Prop preview = p<boolean>({
        default: false
    });

    @Prop isAuthor = p<boolean>({
        default: false
    });

    user: ICourseUser | undefined = undefined;

    numberComments = 9999;

    userAnswer: number = -1;
    hasGivenUp = false;
    disabledResponses: IDistractor[] = [];

    pResponseDistribution: {[id: number]: number} = {};

    updateCourseUser(user: ICourseUser) {
        this.user = user;
    }

    @Lifecycle
    mounted() {
        Fetcher.get(UserService.getLoggedInUser)
            .on(this.updateCourseUser);
    }
    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.getLoggedInUser)
            .off(this.updateCourseUser);
    }

    updateResponseDistribution(newDistribution: {[responseId: number]: number}) {
        this.pResponseDistribution = newDistribution;
    }

    @Lifecycle
    created() {
        if (!this.preview) {
            QuestionService.distributionForQuestion(this.question)
                .then(this.updateResponseDistribution);
        }
        this.numberComments = this.question.comments.length;
    }

    @Watch("question")
    questionChanged(_newQuestion: IQuestion, _oldQuestion: IQuestion) {
        if (!this.preview) {
            QuestionService.distributionForQuestion(this.question)
                .then(this.updateResponseDistribution);
        }
    }

    feedbackEnter(el: HTMLElement, done: Function) {
        el.style.height = "auto";
        const actualHeight = el.clientHeight;
        el.style.height = "0px";
        d3.select(el)
            .style("overflow", "hidden")
            .style("padding-top", "0")
            .style("padding-bottom", "0")
            .transition()
            .style("height", actualHeight + "px")
            .style("opacity", 1)
            .style("margin-bottom", "1em")
            .style("padding-top", "16px")
            .style("padding-bottom", "16px")
            .duration(500)
            .on("end", () => {
                el.style.height = "auto";
                done();
            });
    }

    scrollToExplanation(el: HTMLElement) {
        el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }

    feedbackLeave(el: HTMLElement, done: Function) {
        d3.select(el)
            .transition()
            .style("height", "0px")
            .style("opacity", 0)
            .duration(500)
            .on("end", () => {
                done();
            });
    }

    getResponseStyles(answer: IDistractor) {
        const answerIcon = this.optionIcon(answer);
        return {
            answered: this.disabledResponses.find(x => x == answer) || this.userHasCorrectAnswer,
            correct: this.userHasCorrectAnswer && answerIcon == "done",
            incorrect: this.userHasCorrectAnswer && answerIcon != "done"
        };
    }

    // Getter/Setter for radio buttons
    get questionResponse() {
        return this.userAnswer;
    }

    set questionResponse(newValue: number) {
        if (this.userHasCorrectAnswer) {
            return;
        }

        const distractor = this.question.distractors[newValue];
        this.disabledResponses.push(distractor);
        this.userAnswer = newValue;

        if (!this.preview) {
            QuestionService.submitResponse({ responseId: distractor.id })
                .then(() => {
                    this.$emit("userAnswer", this.userHasCorrectAnswer);
                });
        }
    }

    answerOptionFill(response: IDistractor) {
        if (this.userHasCorrectAnswer) {
            return {
                width: this.pResponseDistribution[response.id] + "%"
            };
        }
        return {};
    }

    distractorIndex(index: number) {
        return String.fromCharCode("A".charCodeAt(0) + index);
    }

    optionIcon(solution: IDistractor) {
        return this.question.solution == solution ? "done" : "clear";
    }

    get userHasCorrectAnswer() {
        return this.question.distractors[this.questionResponse] == this.question.solution;
    }

    resetAnswer() {
        this.disabledResponses.push(this.question.distractors[this.questionResponse]);
        this.questionResponse = -1;
    }

    // Bubble event down to radio button
    clickedResponse(e: MouseEvent) {
        const target = e.target as HTMLElement;
        if (target.tagName != "LABEL" && target.tagName != "INPUT") {
            const input = target.querySelector("input");
            if (input === null) return;

            const event = new MouseEvent("click", {
                bubbles: true
            });
            input.dispatchEvent(event);
        }
    }

    rate(rateType: string) {
        if (!this.preview) {
            return (rateValue: number) => {
                QuestionService.submitRating({
                    questionID: this.question.id,
                    rateType: rateType,
                    rateValue: rateValue
                })
                .then(() => {
                    addEventsToQueue([{
                        name: "Question Rated",
                        description: "Successfully rated question " + rateType,
                        icon: "done"
                    }]);
                });
            };
        } else {
            return "";
        }
    }

    inputHandler(e: KeyboardEvent) {
        if (e.keyCode === 13 && !e.shiftKey) {
            let textBox = <HTMLInputElement>document.getElementById("commentText");
            let content = textBox!.value;
            content = content.trim();
            if (content.length > 0) {
                QuestionService.submitComment(this.question.id, 0, content)
                    .then(x=>this.refreshComments(x, true));
                textBox!.value = "";
            }
        }
    }

    refreshComments(question: IQuestion, display: Boolean) {
        this.question.comments = question.comments;
        if (display) {
            addEventsToQueue([{
                name: "Comment Submitted",
                description: "Comment submitted succesfully",
                icon: "done"
            }]);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/questions/QuestionResponse.vue